import Grid from "../../../common/table";
import React, {useEffect, useState} from "react";
import {AssetFormData} from "../asset-category/type/asset-category.types";
import {ColumnsType} from "antd/es/table";
import SearchCriteria from "../../common/search-criteria/search-criteria";
import {Input, Select} from "antd";
import server from "../../../server";
import {Asset_Status} from "../../../constant/constant";
import {SearchParams} from "../../common/search-criteria/type/search-criteria.type";
import LoadingSkeleton from "../../common/loading-skeleton/loading-skeleton";

interface IAssetInventoryViewProps {
    assetData: AssetFormData[];
    handleNextPage: () => void;
    handlePrevPage: () => void;
    pageSize: number;
    pageNumber: number;
    columns: ColumnsType<AssetFormData>;
    handleAssetSearch: (params: SearchParams) => Promise<void>;
    handleAssetSearchReset: () => void;
    assetStatusFromNavigation: string | undefined;
    loading: boolean
}

const AssetInventoryView = (props: IAssetInventoryViewProps) => {
    const [assetCategories, setAssetCategories] = useState([]);

    useEffect(() => {
        fetchCategories()
    }, [])

    async function fetchCategories() {
        try {
            const categories = await server.asset.category.list();
            setAssetCategories(categories);
        } catch (e) {
            console.log("Error while fetching categories", e);
        }
    }

    return (
        <>
            <h3 className={'asset-inventory heading'}>Asset Inventory</h3>
            <SearchCriteria
                title={"Search Asset"}
                onSearch={props.handleAssetSearch}
                onReset={props.handleAssetSearchReset}
                showReset={true}
                renderTopContent={({values, onChange}) => (
                    <>
                        <div>
                            <label className={"label"}> Asset Code</label>
                            <Input
                                placeholder="Enter Asset Code"
                                value={values.code || ''}
                                onChange={(e) => onChange('code', e.target.value)}
                            />
                        </div>
                        <div>
                            <label className={"label"}> Brand Name</label>
                            <Input
                                placeholder="Enter Brand Name"
                                value={values.brandName || ''}
                                onChange={(e) => onChange('brandName', e.target.value)}
                            />
                        </div>

                        <div>
                            <label className={"label"}>Select Category</label>
                            <Select
                                placeholder={"Select Category"}
                                onChange={(val: any) => onChange('categoryId', val)}
                                value={values.categoryId}
                                allowClear
                                className={"label"}
                            >
                                {assetCategories.map((item: any) => (
                                    <Select.Option key={item.id} value={item.id}>
                                        {item.name}
                                    </Select.Option>
                                ))}
                            </Select>
                        </div>

                        <div>
                            <label className={"label"}>Select Status</label>
                            <Select
                                placeholder={"Select Asset Status"}
                                onChange={(val: any) => onChange('status', val)}
                                value={values.status ? values.status : props.assetStatusFromNavigation}
                                allowClear
                                className={"label"}
                            >
                                {(Object.keys(Asset_Status) as Array<keyof typeof Asset_Status>).map((key) =>
                                    <Select.Option value={key} key={key}>
                                        {Asset_Status[key]}
                                    </Select.Option>
                                )}
                            </Select>
                        </div>
                    </>
                )}
            />

            <div className={'asset-inventory-data-table'}>
                <LoadingSkeleton loading={props.loading}>
                    <Grid
                        bordered={true}
                        dataSource={props.assetData}
                        columns={props.columns}
                        paginationButton={true}
                        pageNumber={props.pageNumber}
                        pageSize={props.pageSize}
                        handleNextPage={props.handleNextPage}
                        handlePrevPage={props.handlePrevPage}
                    />
                </LoadingSkeleton>
            </div>
        </>
    )
}

export default AssetInventoryView;